
import { ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/contexts/CartContext";
import { Button } from "@/components/ui/button";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { CartSidebar } from "./CartSidebar";
import { useState } from "react";

export const CartIcon = () => {
  const { itemCount } = useCart();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Hover preview for desktop */}
      <HoverCard openDelay={300} closeDelay={200}>
        <HoverCardTrigger asChild>
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild>
              <Button 
                variant="ghost" 
                size="icon" 
                className="relative hover:bg-gray-100"
                aria-label={`Voir votre panier${itemCount > 0 ? ` (${itemCount} évènement${itemCount > 1 ? 's' : ''})` : ' (vide)'}`}
              >
                <ShoppingCart className="h-5 w-5 text-gray-700" />
                {itemCount > 0 && (
                  <span 
                    className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-accent flex items-center justify-center text-xs text-white font-medium"
                    aria-label={`${itemCount} article${itemCount > 1 ? 's' : ''} dans le panier`}
                  >
                    {itemCount}
                  </span>
                )}
              </Button>
            </SheetTrigger>
          </Sheet>
        </HoverCardTrigger>
        
        {/* Quick preview on hover - only on desktop */}
        <HoverCardContent className="w-80 p-4 hidden md:block">
          <div className="space-y-2">
            <h4 className="font-medium text-sm text-gray-900">Aperçu du panier</h4>
            {itemCount === 0 ? (
              <p className="text-sm text-gray-600">Votre panier est vide</p>
            ) : (
              <p className="text-sm text-gray-600">
                {itemCount} évènement{itemCount > 1 ? 's' : ''} sélectionné{itemCount > 1 ? 's' : ''}
              </p>
            )}
            <p className="text-xs text-gray-500">Cliquez pour voir le détail</p>
          </div>
        </HoverCardContent>
      </HoverCard>

      {/* Cart sidebar */}
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetContent side="right" className="w-full sm:w-96">
          <SheetHeader>
            <SheetTitle className="text-left">Votre panier</SheetTitle>
          </SheetHeader>
          <CartSidebar onClose={() => setIsOpen(false)} />
        </SheetContent>
      </Sheet>
    </>
  );
};
